import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Website} from "../../website";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../store';
import {BoosterService} from "../services/booster.service";
import {first} from "rxjs/operators";
import {FormControl} from "@angular/forms";

@Component({
    selector: 'db-advanced-settings',
    templateUrl: './advanced-settings.component.html',
    styleUrls: ['./advanced-settings.component.scss'],
    standalone: false
})
export class AdvancedSettingsComponent implements OnInit {

  public website: Website;
  public initialModeGet: any;
  public advancedOptionsGet: any;
  public advancedOptionsSet: any;
  public setOptionKey: FormControl;
  public setOptionValue: FormControl;
  public loading: boolean;

  constructor(
    private _route: ActivatedRoute,
    private _boosterService: BoosterService,
    private _store: Store<fromStore.DbStoreState>,
  ) { }

  ngOnInit() {
    this._initData();
  }

  private _initData(): void {
    this.setOptionKey = new FormControl("");
    this.setOptionValue = new FormControl("");
    this.website = this._route.snapshot.parent.parent.data['website'];
  }

  public getAdvancedOptions() {
    this.loading = true;
    this._boosterService.getAdvancedOptions(this.website?.id)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.loading = false;
        this.advancedOptionsGet = response;
      });
  }

  public getInitialMode() {
    this.loading = true;
    this._boosterService.getInitialMode(this.website?.id)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.loading = false;
        this.initialModeGet = response;
      });
  }

  public setAdvancedOptions() {
    const data = {
      key: this.setOptionKey && this.setOptionKey.value,
      val: this.setOptionValue && this.setOptionValue.value,
    };
    this.loading = true;
    this._boosterService.setAdvancedOptions(this.website?.id, data)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.advancedOptionsSet = response;
        this.loading = false;
      });
  }


}
